var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users"},[_c('h1',[_vm._v("hello users")]),_vm._v(" "),_c('ul',_vm._l((_vm.users),function(user){return _c('li',[_c('h2',[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(user.email))])])}),0),_vm._v(" "),_c('button',{on:{"click":_vm.deleteuser}},[_vm._v("删除")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dca6d69","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users.vue
// module id = null
// module chunks = 